// RITA-1599 (Fund 61) — Hinweis ganz oben auf der Berater-Seite (an der Stelle des ProHolidays-Hinweises), sichtbar
// auf jedem Reiter: gelb, wenn für eine Art keine Vorlage mehr passt, sonst blau; schließbar; darunter der Link „Zur
// Vertragserstellung“ (Reiter „Vertrag“, Karte „Vertragserstellung“).
import React from 'react';
import { Alert, AlertTitle, Box, Button, Typography } from '@mui/material';
import { VorlagenwechselHinweis as Hinweis, ZUR_VERTRAGSERSTELLUNG } from '../services/vorlagenwechsel';

interface Props {
  hinweis: Hinweis;
  onSchliessen: () => void;
  onZurVertragserstellung: () => void;
}

export default function VorlagenwechselHinweis({ hinweis, onSchliessen, onZurVertragserstellung }: Props) {
  return (
    <Alert
      severity={hinweis.schwere}
      onClose={onSchliessen}
      data-testid="vorlagenwechsel-hinweis"
      data-schwere={hinweis.schwere}
      sx={{ mb: 2 }}
    >
      <AlertTitle>{hinweis.titel}</AlertTitle>
      {hinweis.zeilen.map((zeile) => (
        <Typography key={zeile} variant="body2">
          {zeile}
        </Typography>
      ))}
      {/* Wirkt wie ein Link (unterstrichen), ist aber ein Knopf: Er wechselt nur den Reiter dieser Seite. */}
      <Box sx={{ mt: 1 }}>
        <Button
          size="small"
          color="inherit"
          onClick={onZurVertragserstellung}
          sx={{ textTransform: 'none', textDecoration: 'underline', p: 0, minWidth: 0 }}
        >
          {ZUR_VERTRAGSERSTELLUNG}
        </Button>
      </Box>
    </Alert>
  );
}
